// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OP7a","buttons":"styles_buttons___OztL"};